import React from "react";
import { MdArrowDropDownCircle } from "react-icons/md";
import classnames from "classnames";
import moment from "moment";
// lg:space-x-2  space-y-2
const AdditionalServiceCard = ({ onEdit, index, service }) => {
  const { name, _id, startDate, endDate, quantity, rate, isDeleted } = service;
  console.log(isDeleted);
  return (
    <>
      <div
        className={classnames({
          "p-5 lg:w-5/12 w-full border-b-2 border-black flex-shrink  ease-in-out duration-200": true,
          "lg:ml-2": index % 2 !== 0,
          "mt-2": index > 1,
          "bg-white hover:bg-themeYellow shadow-lg": !isDeleted,
          "bg-formBackground": isDeleted === true,
        })}
      >
        <div>
          <h6 className="font-bold text-xs leading-3 tracking-widest uppercase">
            {moment(startDate).format("ll")} - {moment(endDate).format("ll")}
          </h6>
        </div>
        <div className="mt-2">
          <h3 className="font-medium text-2xl leading-7">{name}</h3>
        </div>
        <div className="mt-2 flex justify-between items-center">
          <div>
            <p className="leading-3 text-xs">{quantity} units</p>
            <p className="leading-3 text-xs">Rs {rate} / Unit / Month</p>
          </div>
          {!isDeleted && onEdit && (
            <div>
              <button
                onClick={onEdit}
                type="button"
                className="flex items-center justify-between outline-none"
              >
                <span className="uppercase text-base font-bold mr-2">edit</span>
                <MdArrowDropDownCircle size={16} />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AdditionalServiceCard;
